import React, { FC } from 'react';
import EmailIcon from '@mui/icons-material/Email';
import DescriptionIcon from '@mui/icons-material/Description';
import { FileDocumentEdit } from 'mdi-material-ui';
import { AccountArrowRight } from 'mdi-material-ui';
import StarIcon from '@mui/icons-material/Star';
import CloseIcon from '@mui/icons-material/Close';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import HandshakeIcon from '@mui/icons-material/Handshake';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

type NotificationIconProps = {
    type: string;
};
const NotificationIcon: FC<NotificationIconProps> = ({ type }: NotificationIconProps) => {
    switch (type) {
        case 'NEW_CHAT_MESSAGE':
        case 'NEW_INTERNAL_CHAT_MESSAGE':
            return <EmailIcon />;
        case 'ORDER_CREATED':
            return <DescriptionIcon />;
        case 'ORDER_MODIFIED':
        case 'INTERNAL_ORDER_MODIFIED':
        case 'ORDER_RESENT':
        case 'ORDER_RECEIVED_BY_LAB':
        case 'ORDER_SENT_BY_LAB':
            return <FileDocumentEdit />;
        case 'EXTERNAL_TECH_ORDER_ASSIGNED':
            return <AccountArrowRight />;
        case 'ORDER_RATED':
            return <StarIcon />;
        case 'ORDER_DECLINED':
        case 'ORDER_CANCELED':
            return <CloseIcon />;
        case 'NEW_COMPLETED_DRAFT_ORDER':
            return <AccountArrowRight />;
        case 'INVOICE_BATCH_FAILED':
        case 'INVOICE_BATCH_PARTIAL':
        case 'E_INVOICE_CUSTOMER_ACCEPTED':
        case 'E_INVOICE_CUSTOMER_DECLINED':
        case 'E_INVOICE_CUSTOMER_NOT_READY':
        case 'INVOICE_BATCH_COMPLETED':
            return <ReceiptLongIcon />;
        case 'SUPPLIER_REQUEST_RECEIVED':
        case 'SUPPLIER_REQUEST_APPROVED':
        case 'SUPPLIER_REQUEST_DECLINED':
        case 'CLINIC_REQUEST_RECEIVED':
        case 'CLINIC_REQUEST_APPROVED':
        case 'CLINIC_REQUEST_DECLINED':
            return <HandshakeIcon />;
        case 'PRICE_REQUEST_RECEIVED':
        case 'PRICE_REQUEST_RESPONDED':
        case 'PRICE_REQUEST_APPROVED':
        case 'PRICE_REQUEST_REJECTED':
        case 'PRICE_REQUEST_CANCELLED':
        case 'PRICE_REQUEST_UPDATED':
            return <LocalOfferIcon />;
        case 'PRICE_REQUEST_MESSAGE':
            return <EmailIcon />;
        default:
            return null;
    }
};

export default NotificationIcon;
